import { SubscriptionEndDateFilterValue } from '../config';

export const isSameSubscriptionEndDateFilter = (
  a: SubscriptionEndDateFilterValue,
  b: SubscriptionEndDateFilterValue,
) =>
  a.period === b.period &&
  a.from?.getTime() === b.from?.getTime() &&
  a.to?.getTime() === b.to?.getTime() &&
  a.onlyActive === b.onlyActive;
